export default  [
  /*{
    id: -1,
    nombre: "Error Desconocido",
    descripcion: "Error Desconocido",
    servicio: "atWeb",
    posicion: "-5px -12542px"
  },*/
  {
    id: 0,
    nombre: "OK",
    descripcion: "La consulta http tuvo respuesta satisfactoria.",
    servicio: "atWeb, atMeta, ativr, atMobile",
    posicion: "-347px -7064px"
  },
  {
    id: 1,
    nombre: "Error de Configuración",
    descripcion: "Error en la Configuración del Monitoreo",
    servicio: "atWeb",
    posicion: "-347px -1082px"
  },
  /*{
    id: 2,
    nombre: "Error fatal en el monitoreo.",
    descripcion: "FATAL",
    servicio: "atWeb",
    posicion: ""
  },*/
  {
    id: 3,
    nombre: "Timeout",
    descripcion: "Tiempo de espera agotado o timeout",
    servicio: "atWeb, atMeta, atMobile",
    posicion: "-643px -2906px"
  },
  {
    id: 4,
    nombre: "No se resolvió URL",
    descripcion: "No se conoce dirección IP del host",
    servicio: "atWeb, atMeta",
    posicion: "-643px -5506px"
  },
  {
    id: 5,
    nombre: "Periodo sin monitoreo",
    descripcion: "El objetivo no fue monitoreado en ese período",
    servicio: "atWeb",
    posicion: "-340px -6804px"
  },
  {
    id: 6,
    nombre: "Timeout de la Página",
    descripcion: "Timeout en la Descarga Completa de la Página",
    servicio: "atWeb",
    posicion: "-643px -4726px"
  },
  {
    id: 7,
    nombre: "Timeout",
    descripcion: "Timeout intentando en modo persistente infinito",
    servicio: "atWeb",
    posicion: "-643px -2905px"
  },
  {
    id: 8,
    nombre: "OK",
    descripcion: "OK al segundo intento",
    servicio: "atWeb",
    posicion: "-347px -7848px"
  },
  {
    id: 9,
    nombre: "DNS OK No autoritativo",
    descripcion: "La respuesta del DNS no es autoritativa, es decir, la respuesta proviene de tablas temporales (cache) de un DNS no oficial del dominio.",
    servicio: "atWeb",
    posicion: "-347px -8368px"
  },
  {
    id: 10,
    nombre: "Sin dominio",
    descripcion: "Dominio consultado no existe",
    servicio: "atWeb",
    posicion: "-643px -1086px"
  },
  {
    id: 11,
    nombre: "Sin nombre",
    descripcion: "Nombre consultado no existe",
    servicio: "atWeb",
    posicion: "-643px -1605px"
  },
  {
    id: 12,
    nombre: "Sin servidor",
    descripcion: "DNS consultado no existe",
    servicio: "atWeb",
    posicion: "-643px -2385px"
  },
  {
    id: 13,
    nombre: "Error de contenido",
    descripcion: "El contenido del servicio y/o aplicación web, App Mobile o Mensaje del servidor IVR no coincide con el patrón definido. Esto significa que se obtiene un resultado distinto a lo esperado.",
    servicio: "atWeb, atMeta, atMobile",
    posicion: "-347px -1341px"
  },
  {
    id: 14,
    nombre: "DNS OK autoritativo",
    descripcion: "DNS Ok Autoritativo",
    servicio: "atWeb",
    posicion: "-347px -8107px"
  },
  {
    id: 15,
    nombre: "Sin respuesta",
    descripcion: "Servidor no responde",
    servicio: "atWeb",
    posicion: "-643px -2127px"
  },
  {
    id: 16,
    nombre: "Sin respuesta",
    descripcion: "Servidor no responde",
    servicio: "atWeb",
    posicion: "-643px -2127px"
  },
  {
    id: 17,
    nombre: "Servidor Correo OK",
    descripcion: "Fue posible obtener conexión con el servidor de correo.",
    servicio: "atWeb",
    posicion: "-643px -304px"
  },
  {
    id: 18,
    nombre: "Error Autenticación",
    descripcion: "Problema de Autenticación",
    servicio: "atWeb",
    posicion: "-347px -564px"
  },
  {
    id: 19,
    nombre: "Error SMTP inseguro",
    descripcion: "Relay abierto",
    servicio: "atWeb",
    posicion: "-347px -4982px"
  },
  {
    id: 20,
    nombre: "Downtime Funcional",
    descripcion: "Downtime Funcional",
    servicio: "atWeb",
    posicion: "-42px -8682px"
  },
  {
    id: 21,
    nombre: "TXT vacío",
    descripcion: "En consulta de DNS CHAOS, el campo TXT se encuentra vacio.",
    servicio: "atWeb",
    posicion: "-643px -2646px"
  },
  {
    id: 22,
    nombre: "Campo no disponible",
    descripcion: "Campo CHAOS no disponible para consulta en DNS.",
    servicio: "atWeb",
    posicion: "-42px -7900px"
  },
  {
    id: 23,
    nombre: "Patrón de error encontrado",
    descripcion: "Patrón de error conocido encontrado",
    servicio: "atWeb",
    posicion: "-347px -9148px"
  },
  {
    id: 24,
    nombre: "Certificado inválido",
    descripcion: "Certificado SSL Inválido",
    servicio: "atWeb",
    posicion: "-42px -8159px"
  },
  {
    id: 25,
    nombre: "Faltaron Elementos",
    descripcion: "Faltaron Elementos por Descargar",
    servicio: "atWeb, atMeta",
    posicion: "-347px -5503px"
  },
  {
    id: 26,
    nombre: "Terminado con errores",
    descripcion: "Existieron errores en el monitoreo, pero pueden no ser de importancia",
    servicio: "atWeb",
    posicion: "-652px -6811px"
  },
  {
    id: 27,
    nombre: "Timeout Javascript",
    descripcion: "Tiempo de espera agotado en paso Javascript",
    servicio: "atWeb, atMeta",
    posicion: "-643px -4205px"
  },
  /*{
    id: 28,
    nombre: "Error previo",
    descripcion: "Paso no ejecutado por error anterior",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 29,
    nombre: "Error USSD",
    descripcion: "El paso devolvió un error USSD desde el operador",
    servicio: "atWeb",
    posicion: ""
  },*/
  {
    id: 30,
    nombre: "Mail OK",
    descripcion: "Mail Recibido OK",
    servicio: "atWeb",
    posicion: "-340px -6543px"
  },
  {
    id: 31,
    nombre: "Error correo",
    descripcion: "Error en envio de correo",
    servicio: "atWeb",
    posicion: "-347px -2125px"
  },
  {
    id: 32,
    nombre: "Error Conexión MailBox",
    descripcion: "Error Conexión MailBox",
    servicio: "atWeb",
    posicion: "-347px -825px"
  },
  {
    id: 33,
    nombre: "Timeout",
    descripcion: "Timeout en recepción de correo",
    servicio: "atWeb",
    posicion: "-643px -2905px"
  },
  {
    id: 34,
    nombre: "Error en la recepción del correo",
    descripcion: "Error en la recepción del correo por parte del servidor",
    servicio: "atWeb",
    posicion: "-347px -4723px"
  },
  {
    id: 35,
    nombre: "Error de contenido DNS",
    descripcion: "El contenido de la respuesta del DNS no coincide con el patron",
    servicio: "atWeb",
    posicion: "-347px -1863px"
  },
  {
    id: 36,
    nombre: "Error conocido encontrado en DNS",
    descripcion: "El contenido de la respuesta del DNS corresponde a un error conocido",
    servicio: "atWeb",
    posicion: "-347px -1605px"
  },
  {
    id: 40,
    nombre: "Error SOAP",
    descripcion: "Error SOAP en el servidor",
    servicio: "atWeb",
    posicion: "-347px -5244px"
  },
  /*{
    id: 60,
    nombre: "Error dos patrones",
    descripcion: "No se encontró ninguno de los dos patrones buscados",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 62,
    nombre: "Error primer patrón",
    descripcion: "No se encontró el primer patrón buscado",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 64,
    nombre: "Error segundo patrón",
    descripcion: "No se encontró el segundo patrón buscado",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 66,
    nombre: "Error SIF",
    descripcion: "No se encontró el patrón SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 67,
    nombre: "Error B2B",
    descripcion: "No se encontró el patrón B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 68,
    nombre: "Error B2B-SIF",
    descripcion: "No se encontró el patrón B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 69,
    nombre: "Error SAB",
    descripcion: "No se encontró el patrón SAB",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 70,
    nombre: "Error SAB-SIF",
    descripcion: "No se encontró el patrón SAB-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 71,
    nombre: "Error SAB-B2B",
    descripcion: "No se encontró el patrón SAB-B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 72,
    nombre: "Error SAB-B2B-SIF",
    descripcion: "No se encontró el patrón SAB-B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 73,
    nombre: "Error SRX",
    descripcion: "No se encontró el patrón SRX",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 74,
    nombre: "Error SRX-SIF",
    descripcion: "No se encontró el patrón SRX-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 75,
    nombre: "Error SRX-B2B",
    descripcion: "No se encontró el patrón SRX-B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 76,
    nombre: "Error SRX-B2B-SIF",
    descripcion: "No se encontró el patrón SRX-B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 77,
    nombre: "Error SRX-SAB",
    descripcion: "No se encontró el patrón SRX-SAB",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 78,
    nombre: "Error SRX-SAB-SIF",
    descripcion: "No se encontró el patrón SRX-SAB-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 79,
    nombre: "Error SRX-SAB-B2B",
    descripcion: "No se encontró el patrón SRX-SAB-B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 80,
    nombre: "Error SRX-SAB-B2B-SIF",
    descripcion: "No se encontró el patrón SRX-SAB-B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 81,
    nombre: "Error TOM",
    descripcion: "No se encontró el patrón TOM",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 82,
    nombre: "Error TOM-SIF",
    descripcion: "No se encontró el patrón TOM-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 83,
    nombre: "Error TOM-B2B",
    descripcion: "No se encontró el patrón TOM-B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 84,
    nombre: "Error TOM-B2B-SIF",
    descripcion: "No se encontró el patrón TOM-B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 85,
    nombre: "Error TOM-SAB",
    descripcion: "No se encontró el patrón TOM-SAB",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 86,
    nombre: "Error TOM-SAB-SIF",
    descripcion: "No se encontró el patrón TOM-SAB-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 87,
    nombre: "Error TOM-SAB-B2B",
    descripcion: "No se encontró el patrón TOM-SAB-B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 88,
    nombre: "Error TOM-SAB-B2B-SIF",
    descripcion: "No se encontró el patrón TOM-SAB-B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 89,
    nombre: "Error TOM-SRX",
    descripcion: "No se encontró el patrón TOM-SRX",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 90,
    nombre: "Error TOM-SRX-SIF",
    descripcion: "No se encontró el patrón TOM-SRX-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 91,
    nombre: "Error TOM-SRX-B2B",
    descripcion: "No se encontró el patrón TOM-SRX-B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 92,
    nombre: "Error TOM-SRX-B2B-SIF",
    descripcion: "No se encontró el patrón TOM-SRX-B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 93,
    nombre: "Error TOM-SRX-SAB",
    descripcion: "No se encontró el patrón TOM-SRX-SAB",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 94,
    nombre: "Error TOM-SRX-SAB-SIF",
    descripcion: "No se encontró el patrón TOM-SRX-SAB-SIF",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 95,
    nombre: "Error TOM-SRX-SAB-B2B",
    descripcion: "No se encontró el patrón TOM-SRX-SAB-B2B",
    servicio: "atWeb",
    posicion: ""
  },
  {
    id: 96,
    nombre: "Error TOM-SRX-SAB-B2B-SIF",
    descripcion: "No se encontró el patrón TOM-SRX-SAB-B2B-SIF",
    servicio: "atWeb",
    posicion: ""
  },*/
  {
    id: 200,
    nombre: "OK",
    descripcion: "OK",
    servicio: "atWeb",
    posicion: "-347px -7326px"
  },
  {
    id: 204,
    nombre: "Sin contenido",
    descripcion: "Sin contenido",
    servicio: "atWeb",
    posicion: "-347px -7584px"
  },
  {
    id: 301,
    nombre: "Redirección Permanente",
    descripcion: "Redirección Permanente",
    servicio: "atWeb",
    posicion: "-42px -43px"
  },
  {
    id: 302,
    nombre: "Redireccionado",
    descripcion: "Redireccionado",
    servicio: "atWeb",
    posicion: "-347px -9670px"
  },
  {
    id: 304,
    nombre: "Not Modified",
    descripcion: "Not Modified",
    servicio: "atWeb",
    posicion: "-42px -306px"
  },
  {
    id: 307,
    nombre: "Movido Temporalmente",
    descripcion: "Movido Temporalmente",
    servicio: "atWeb",
    posicion: "-42px -568px"
  },
  {
    id: 400,
    nombre: "Error 400",
    descripcion: "Requerimiento sintácticamente incorrecto",
    servicio: "atWeb",
    posicion: "-42px -835px"
  },
  {
    id: 401,
    nombre: "Error 401",
    descripcion: "Acceso no autorizado",
    servicio: "atWeb",
    posicion: "-42px -1097px"
  },
  {
    id: 403,
    nombre: "Error 403",
    descripcion: "Permiso denegado",
    servicio: "atWeb",
    posicion: "-42px -1358px"
  },
  {
    id: 404,
    nombre: "Error 404",
    descripcion: "Página no encontrada",
    servicio: "atWeb",
    posicion: "-42px -1620px"
  },
  {
    id: 405,
    nombre: "Error 405",
    descripcion: "Método de acceso no autorizado",
    servicio: "atWeb",
    posicion: "-42px -1882px"
  },
  {
    id: 406,
    nombre: "Error 406",
    descripcion: "Página inaceptable",
    servicio: "atWeb",
    posicion: "-42px -2145px"
  },
  {
    id: 407,
    nombre: "Error 407",
    descripcion: "Falló identificación en proxy",
    servicio: "atWeb",
    posicion: "-42px -2408px"
  },
  {
    id: 408,
    nombre: "Error 408",
    descripcion: "Tiempo de espera agotado",
    servicio: "atWeb",
    posicion: "-42px -2671px"
  },
  {
    id: 409,
    nombre: "Error 409",
    descripcion: "Conflicto en la solicitud",
    servicio: "atWeb",
    posicion: "-42px -2929px"
  },
  {
    id: 410,
    nombre: "Error 410",
    descripcion: "Documento inaccesible",
    servicio: "atWeb",
    posicion: "-42px -3190px"
  },
  {
    id: 411,
    nombre: "Error 411",
    descripcion: "Longitud requerida",
    servicio: "atWeb",
    posicion: "-42px -3452px"
  },
  {
    id: 412,
    nombre: "Error 412",
    descripcion: "Condición falsa",
    servicio: "atWeb",
    posicion: "-42px -3715px"
  },
  {
    id: 413,
    nombre: "Error 413",
    descripcion: "Requerimiento muy grande",
    servicio: "atWeb",
    posicion: "-42px -3976px"
  },
  {
    id: 414,
    nombre: "Error 414",
    descripcion: "URL muy larga",
    servicio: "atWeb",
    posicion: "-42px -4240px"
  },
  {
    id: 415,
    nombre: "Error 415",
    descripcion: "Medio no soportado",
    servicio: "atWeb",
    posicion: "-42px -4501px"
  },
  {
    id: 416,
    nombre: "Error 416",
    descripcion: "Rango no satisfecho",
    servicio: "atWeb",
    posicion: "-42px -4762px"
  },
  {
    id: 417,
    nombre: "Error 417",
    descripcion: "'expect' no encontrado",
    servicio: "atWeb",
    posicion: "-42px -5023px"
  },
  {
    id: 439,
    nombre: "Error 439",
    descripcion: "Error 439",
    servicio: "atWeb",
    posicion: "-42px -5286px"
  },
  {
    id: 500,
    nombre: "Error 500",
    descripcion: "Falla interna del servidor",
    servicio: "atWeb",
    posicion: "-42px -5550px"
  },
  {
    id: 501,
    nombre: "Error 501",
    descripcion: "No implementado",
    servicio: "atWeb",
    posicion: "-42px -5811px"
  },
  {
    id: 502,
    nombre: "Error 502",
    descripcion: "Error de proxy",
    servicio: "atWeb",
    posicion: "-42px -6073px"
  },
  {
    id: 503,
    nombre: "Error 503",
    descripcion: "Servicio no disponible",
    servicio: "atWeb",
    posicion: "-42px -6334px"
  },
  {
    id: 504,
    nombre: "Error 504",
    descripcion: "Timeout de proxy",
    servicio: "atWeb",
    posicion: "-42px -6598px"
  },
  {
    id: 505,
    nombre: "Error 505",
    descripcion: "No soportado",
    servicio: "atWeb",
    posicion: "-42px -6858px"
  },
  {
    id: 520,
    nombre: "Error 520",
    descripcion: "Falla interna del servidor",
    servicio: "atWeb",
    posicion: "-42px -7119px"
  },
  {
    id: 521,
    nombre: "Error 521",
    descripcion: "Falla interna del servidor",
    servicio: "atWeb",
    posicion: "-42px -7379px"
  },
  {
    id: 522,
    nombre: "Error 522",
    descripcion: "Falla interna del servidor",
    servicio: "atWeb",
    posicion: "-42px -7643px"
  },
  {
    id: 600,
    nombre: "Error desconocido IVR",
    descripcion: "Error desconocido IVR",
    servicio: "atIVR",
    posicion: "-347px -3165px"
  },
  {
    id: 601,
    nombre: "Troncal congestionado",
    descripcion: "Servidor de telefonia caido (congestion).",
    servicio: "atIVR",
    posicion: "-347px -6285px"
  },
  {
    id: 602,
    nombre: "Operador contestó",
    descripcion: "EL operador atendió la llamada",
    servicio: "atIVR",
    posicion: "-340px -8889px"
  },
  {
    id: 603,
    nombre: "Troncal ocupado",
    descripcion: "Troncal ocupado",
    servicio: "atIVR",
    posicion: "-347px -5245px"
  },
  {
    id: 604,
    nombre: "Llamada no contestada",
    descripcion: "No se pudo realizar el monitoreo ya que el troncal no contesto la llamada",
    servicio: "atIVR",
    posicion: "-347px -6282px"
  },
  {
    id: 605,
    nombre: "Operador no contestó",
    descripcion: "EL operador no atendió la llamada",
    servicio: "atIVR",
    posicion: "-347px -8627px"
  },
  {
    id: 607,
    nombre: "Timeout",
    descripcion: "Tiempo de espera de la llamada agotado o silencio del audio mayor al esperado",
    servicio: "atIVR",
    posicion:"-643px -4464px"
  },
  {
    id: 610,
    nombre: "LLamada colgada",
    descripcion: "La llamada dura menos de lo presupuestado (corte previo).",
    servicio: "atIVR",
    posicion: "-347px -5762px"
  },
  {
    id: 613,
    nombre: "Error de contenido",
    descripcion: "El contenido del audio capturado no coincide con el patrón.",
    servicio: "atIVR",
    posicion: "-347px -6023px"
  },
  /*{
    id: 699,
    nombre: "Inhibición de monitoreo",
    descripcion: "Termina monitoreo por condición de inhibición encontrada.",
    servicio: "atWeb, atMeta, atIVR",
    posicion: ""
  },*/
  {
    id: 723,
    nombre: "Error patrón imagen",
    descripcion: "No se encontro el patrón de imagen buscado",
    servicio: "atWeb, atMobile",
    posicion: "-347px -3684px"
  },
  {
    id: 724,
    nombre: "Error patrón imagen inverso",
    descripcion: "Se encontro un patrón de imagen no esperado o erroneo",
    servicio: "atWeb, atMobile",
    posicion: "-347px -3945px"
  },
  {
    id: 725,
    nombre: "Error patrón imagen OCR",
    descripcion: "No se encontro el patrón OCR dentro de imagen buscado",
    servicio: "atWeb, atMobile",
    posicion: "-347px -4201px"
  },
  {
    id: 726,
    nombre: "Patrón OCR inverso encontrado",
    descripcion: "Se encontró patrón de OCR inverso buscado",
    servicio: "atWeb, atMobile",
    posicion: "-649px -6023px"
  },
  {
    id: 730,
    nombre: "Error patrón token",
    descripcion: "Error en obtención de Token remoto (Correo u aplicación externa)",
    servicio: "atWeb, atMobile",
    posicion: "-347px -4462px"
  },
  /*{
    id: 999,
    nombre: "Sin respuesta desde ISP",
    descripcion: "Se intento realizar una medicion en ISP, pero no se obtuvo una respuesta. Se asume estado con error para efectos de alertas globales",
    servicio: "atWeb",
    posicion: "-5px -21654px"
  },*/
  {
    id: 1000,
    nombre: "Elemento excluído",
    descripcion: "Elemento excluído",
    servicio: "atWeb, atMeta",
    posicion: "-42px -9201px"
  },
  {
    id: 1001,
    nombre: "Conexión Rechazada",
    descripcion: "Conexión Rechazada",
    servicio: "atWeb, atMeta",
    posicion: "-42px -8419px"
  },
  {
    id: 1002,
    nombre: "Servidor Cerró Conexión",
    descripcion: "Servidor Cerró Conexión",
    servicio: "atWeb, atMeta",
    posicion: "-643px -44px"
  },
  {
    id: 1003,
    nombre: "Servidor no Encontrado",
    descripcion: "Servidor no Encontrado",
    servicio: "atWeb, atMeta",
    posicion: "-643px -566px"
  },
  {
    id: 1004,
    nombre: "Timeout en Conexión",
    descripcion: "Timeout en Conexión",
    servicio: "atWeb, atMeta",
    posicion: "-643px -3686px"
  },
  {
    id: 1005,
    nombre: "Elemento del Servidor No Encontrado",
    descripcion: "A pesar que el servidor web indico que existía el elemento interno o externo, este no puedo ser encontrado",
    servicio: "atWeb, atMeta",
    posicion: "-42px -8940px"
  },
  {
    id: 1006,
    nombre: "Timeout de la Operación del Socket",
    descripcion: "Se intento recuperar un elemento interno o externo que indico el elemento principal, pero el primero no respondió y no se pudo concretar la operación del socket. (puede darse el caso que este haya respondido correctamente al inicio",
    servicio: "atWeb, atMeta",
    posicion: "-643px -3426px"
  },
  {
    id: 1007,
    nombre: "Petición Cancelada",
    descripcion: "Se intento recuperar un elemento interno o externo que indico el elemento principal. pero la petición a este fue rechazada (por lo general pasa por scripts alojados en servidores de terceros)",
    servicio: "atWeb, atMeta",
    posicion: "-347px -9409px"
  },
  {
    id: 1999,
    nombre: "Error de Red Desconocido",
    descripcion: "Error de Red Desconocido",
    servicio: "atWeb",
    posicion: "-347px -2384px"
  },
  {
    id: 2000,
    nombre: "Sin Medicion",
    descripcion: "Sin Medicion. No se pudo obtener status del monitoreo",
    servicio: "atMeta",
    posicion: "-643px -1345px"
  },
  /*{
    id: 3000,
    nombre: "Marcado cliente",
    descripcion: "Periodo marcado por el cliente",
    servicio: "atWeb, atMeta, atIVR, atMobile",
    posicion: "-5px -25554px"
  },*/
  {
    id: 9999,
    nombre: "Error desconocido IVR",
    descripcion: "Error desconocido IVR",
    servicio: "atWeb",
    posicion: "-347px -3164px"
  },
  {
    id: 999999,
    nombre: "Error desconocido en Script",
    descripcion: "Error desconocido en Script",
    servicio: "atWeb, atMeta, atMobile",
    posicion: "-347px -2904px"
  }
]